'use strict';

import Model from './model.js';
import User from './user.js';
import Employee from './employee.js';
import LeaveRequest from './leave-request.js';
import LeaveType from './leave-type.js';
import {consts as LeaveRequestConsts} from 'newModels/leave-request.js';
import moment from 'moment';

export default class ActionLog extends Model {
    urlRoot() { return '/ActionLogs'; }

    constructor() {
        super(...arguments);
        this.employee = null;
        this.user = null;
        this.approvedBy = null;
        this.leaveType = null;
    }

    initialize() {
        this.idAttribute = 'objectId';
        return super.initialize(...arguments);
    }

    fetchUser() {
        if (this.user) {
            return Promise.resolve(this.user);
        }

        return new User({id: this.get('userId')}).fetch()
            .then(model => {
                this.user = model;
                return this.user;
            });
    }

    getEmployee() {
        return this.employee;
    }

    fetchEmployee() {
        if (this.employee) {
            return Promise.resolve(this.employee);
        }

        if (!this.get('employeeId')) {
            return Promise.resolve(null);
        }

        const employee = app.employees.find(
            emp => emp.get('objectId') === this.get('employeeId')
        );
        if (employee) {
            this.employee = employee;
            return Promise.resolve(employee);
        }

        return new Employee({objectId: this.get('employeeId')})
            .fetch()
            .then(model => {
                this.employee = model;
                return this.employee;
            });
    }

    getCreatedAt() {
        return moment(this.get('createdAt')).fromNow();
    }

    getCreatedTime() {
        return moment(this.get('createdAt')).format('hh:mm a');
    }

    getLeaveType() {
        return this.leaveType;
    }

    fetchLeaveType() {
        if (!this.get('metadata').leaveRequestId) {
            return Promise.resolve(null);
        }

        return new LeaveRequest({
                objectId: this.get('metadata').leaveRequestId
            })
            .fetch()
            .then(model => {
                const leaveType = app.leaveTypes.find(
                    type => type.get('objectId') === model.get('typeId')
                );
                if (leaveType) {
                    this.leaveType = leaveType;
                    return this.leaveType;
                }
                return new LeaveType({
                        objectId: model.get('typeId')
                    })
                    .fetch()
                    .then(model => {
                        this.leaveType = model;
                        return this.leaveType;
                    });
            });
    }

    getApprovalType() {
        const type = this.get('type');
        if (type !== 'leave-request') {
            return null;
        }
        const subType = this.get('subType');
        const leaveRequestMap = {
            request: 'Requested',
            approve: 'Approved',
            cancel: 'Cancelled',
            reject: 'Rejected'
        };
        return leaveRequestMap[subType] || 'Leave';
    }

    getMetadata() {
        const type = this.get('type');
        const metadata = this.get('metadata');
        if (type === 'leave-request') {
            const dateFrom = moment(metadata.dateFrom);
            if (!metadata.dateTo) {
                return dateFrom.format('D MMM');
            }
            const dateTo = moment(metadata.dateTo);
            return dateFrom.format('D MMM') + ' to ' + dateTo.format('D MMM');
        }
    }

    getIconClass() {
        const type = this.get('type');
        if (type !== 'leave-request') {
            return null;
        }
        const subType = this.get('subType');
        const leaveRequestMap = {
            request: 'calendar-plus-o',
            approve: 'calendar-check-o',
            cancel: 'calendar-times-o',
            reject: 'remove'
        };
        return leaveRequestMap[subType];
    }

    getTextColor() {
        const type = this.get('type');
        if (type !== 'leave-request') {
            return null;
        }
        const subType = this.get('subType');
        const leaveRequestMap = {
            request: 'text-success',
            approve: 'text-navy',
            cancel: 'text-danger',
            reject: 'text-danger'
        };
        return leaveRequestMap[subType];
    }

    getLink(layer = 0) {
        if (this.get('type') === 'leave-request') {
            const metadata = this.get('metadata');
            if (
                metadata.status === LeaveRequestConsts.STATUS_AWAITING &&
                layer > (metadata.approvalStatus || 0) + 1
            ) {
                return false;
            }

            return '#calendar/' + metadata.leaveRequestId + '/view';
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./app/new-models/action-log.js